<template>
    <div>
        
        <div class="row">
            <div class="col-sm-10">
                

                <template v-if="flag == 3">
                    <b-button class="btn btn-primary rounded p-2 pr-4 pl-4 " @click="exportEmailPhone"><b-icon icon="code-slash" ></b-icon> Download Template</b-button>
                     
                    <h5 class="mt-3">Upload the downloaded excel file after the modification.</h5>
                </template>
                
                
            </div>
            <div class="col-sm-2">
                <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>       
        

        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <b-form-file id="datafile" name="datafile" ref="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
            <br />
            <!--<b-button type="button" v-if="has_file" @click="checkFileData" variant="primary" size="lg">Validate file data</b-button>
            <b-button type="button" v-if="has_file" @click="processFileData" variant="primary" size="lg">Process file data</b-button>-->
            
            
            <div v-if='errormsg'>
                <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                <ul class="list-group mt-4">           
                    <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                </ul>
            </div>


            <div v-if="show_employee_list"> 
                <div class="mt-4 custom-search">
                    <h3>Imported employees ({{people}})</h3>

                    <b-input-group >
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search by Employee / Position / Branch / Email / Phone" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>


                <div class="card-body container">
                    <div class="row border-bottom  py-2">                
                        <div class="col-sm-4 text-uppercase py-1 font-weight-bold row pl-4">
                            Organaizational Info
                        </div>
                        <div class="col-sm-3 text-uppercase py-1 font-weight-bold ">
                            Contact Info
                        </div>
                        <div class="col-sm-5 text-uppercase py-1 font-weight-bold pl-1">
                            Actions
                        </div>                
                    </div>

                    <div class="row border-bottom py-2" v-for="employee in paginatedData" :key="employee.employee_id">
                        <div class="col-sm-4 justify-content-center row pl-4">
                            <div class="col-sm-4 px-0">
                                <img v-bind:src="$api_url+'/images/employee/'+ employee.company_id + '/' + employee.pic" class="img-fluid img-thumbnail" />
                            </div>
                            <div class="col-sm-8">
                                <div class="text-uppercase py-1 font-weight-bold">{{employee.name}}</div>
                                <div>
                                    {{employee.jobposition}}<br />
                                    {{employee.department}}                        
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3 ">
                            {{employee.email}}<br />
                            {{employee.phone}}<br />
                            {{employee.employee_code}}
                        </div>
                        
                        <div class="col-sm-5 px-0">
                            <b-button-group >
                                <b-button variant="outline-secondary" title="Edit" v-if="ce" @click="editEmployee(employee.employee_id , 0)">Info</b-button>
                                <b-button variant="outline-secondary" title="Contract" @click="editEmployee(employee.employee_id , 1)">Contract</b-button>
                                <b-button variant="outline-secondary" title="Investment" v-if="ce" @click="editEmployee(employee.employee_id , 2)">Investment</b-button>
                                <b-button variant="outline-secondary" title="Tax Card" v-if="ce" @click="editEmployee(employee.employee_id , 3)">Tax Card</b-button>
                                <b-button variant="outline-secondary" title="Pay Slip" v-if="ce" @click="editEmployee(employee.employee_id , 4)">Payslip</b-button>
                                <b-button variant="outline-secondary" title="Challan" v-if="ce" @click="editEmployee(employee.employee_id , 5)">Challan</b-button>
                            </b-button-group>
                        </div>
                    </div>
                    <div class="row p-2 float-right" v-if="paginatedData.length > 0">
                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
                    <div class="row p-2" v-if="paginatedData.length == 0">
                        {{blankmsg}}
                    </div>
                </div>
            </div>



        </b-overlay>
  </div>
</template>
<script>

    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id); 
            //alert(this.cu);
        },
        props: ['pageurl' , 'flg'],
        data(){            
            
            return {

                pageUrl : this.$api_url,
                flag : this.flg,
                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                showoverlay : false,
                show_employee_list : false,
                people : 0,
                blankmsg : 'Fetching data..',

                upload_url : '',
                process_url : '',

                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                employees : [],                
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search_group : {name:'', email:'', phone:'' },
                search_by_id : {department_id:0, jobposition_id:0 , branch_id:0},

                depertments : [],
                jobtypes : [],
                branches : [],
                pgurl : this.$api_url,

                search:  '',
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                
            }
        },
        methods:{
            
            setUrls:function()
            {
                this.flag = parseInt(this.flag);
                if(this.flag == 3)
                {
                    
                    this.upload_url = this.$api_url+"/pf/employee/confirm-forfeiture-fund-data";
                    this.process_url = this.$api_url+'/pf/employee/confirm-forfeiture-fund-data/processdata';               
 
                }
                

            },
            exportEmailPhone: function(flg = 0)
            {
                if(!this.checkNet()) return false;

                
                let currentObj = this;
                this.$bvToast.toast('It might take a while', {
                                        title: `Info`,
                                        variant: 'info',
                                        solid: true 
                                    });
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_ids', 'all');
                formData.append('flg', 6);
                formData.append('forupdate', 1);
                
                axios.post(this.$api_url+'/pf/employee/forfeiture-template-downloand', formData)
                    .then(function (response) 
                    {                 
                        this.showoverlay = false;                                                   
                        //window.open(response.data);
                        var fileURL = response.data;
                        
                        this.download_file(fileURL);
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            }, 

            uploadFile:function(event) 
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.show_employee_list = false;
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];
                
                var handle_return = this.checkFileType(event,'datafile',['.xlsx','.xls']);
                if(handle_return == false)
                {
                    return 0;
                }

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.upload_url, data , config).
                    then(function (response){

                        this.has_file = true;
                         
                        this.$bvToast.toast('Processing the data feed file.', {
                                            title: `Job on progress`,
                                            variant: 'info',
                                            solid: true
                                        });                        
                    
                        this.processFileData();
                        
                    }.bind(this)).
                    catch(function (error) 
                            {
                                //alert(error.response.data.errors);
                            });
            },
            processFileData:function()
            {
                window.location.href = this.process_url;   
            },


            
            resetPagination()
            {
                this.pagination.currentPage = 1;
                this.pagination.prevPage = '';
                this.pagination.nextPage = '';
            },
            paginate(array, length, pageNumber) 
            {
                let l = parseInt(array.length);
                let m = parseInt(length);
                this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
                this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
                this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
                this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';

                if(l > 0)
                {
                    this.pagination.pages = Math.ceil(l / m);
                }
                this.people = l;
                return array.slice((pageNumber - 1) * length, pageNumber * length);
            },
            editEmployee:function(x , i)
            {    
                if(!this.checkNet()) return false;
                
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response) 
                    {                                                                    
                        if(i > 0)
                            window.location.href = this.$api_url+'/employee/info?#=' + i;
                        else
                            window.location.href = this.$api_url+'/employee/info';
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.errormsg = error.response.data.errors;
                    });

            },

            
        },
        created: function(){
            this.setUrls();

            Fire.$on('reloadUsers', () => {this.processFileData()})
        },
        
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.employees;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                       
                }

                this.people = filtered_list.length;
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
